import { DATE_FORMATS } from 'emma-common-ts';
import { EMMA_COLORS } from '@emma-helpers/chart-colors.helper';

export const lineStyles = [
  {
    lineColor: EMMA_COLORS.ALTGREEN,
    lineThickness: 3,
  },
  {
    lineColor: EMMA_COLORS.ALTDARKBLUE,
    lineThickness: 3,
  },
  {
    lineColor: EMMA_COLORS.ALTBLUE,
    lineThickness: 3,
  },
  {
    lineColor: EMMA_COLORS.ALTORANGE,
    lineThickness: 3,
  },
];

export const getOptions = () => ({
  ...{
    hideCredits: true,
    type: 'serial',
    categoryField: 'date',
    dataDateFormat: DATE_FORMATS.API,
    colors: [
      EMMA_COLORS.ALTGREEN,
      EMMA_COLORS.ALTDARKBLUE,
      EMMA_COLORS.ALTBLUE,
      EMMA_COLORS.ALTORANGE,
      '#a14eff',
      '#f0ff04',
      '#FF6600',
      '#FCD202',
      '#B0DE09',
      '#0D8ECF',
      '#2A0CD0',
      '#CD0D74',
      '#CC0000',
      '#00CC00',
      '#0000CC',
      '#DDDDDD',
      '#999999',
      '#333333',
      '#990000',
    ],
    color: '#0A2C33',
    fontFamily: 'Rubik',
    categoryAxis: {
      autoRotateCount: 15,
      autoRotateAngle: 30,
      autoWrap: true,
      equalSpacing: false,
      parseDates: true,
      axisColor: '#D8D8D8',
      boldPeriodBeginning: false,
      gridAlpha: 0,
      minorGridAlpha: 0,
      titleColor: '',
    },
    chartCursor: {
      enabled: true,
      animationDuration: 0.1,
      categoryBalloonDateFormat: DATE_FORMATS.DAY_MONTH_YEAR,
      cursorColor: '#00A263',
      zoomable: false,
    },
    balloon: {
      animationDuration: 0.3,
      fadeOutDuration: 0.3,
    },
    legend: {
      enabled: true,
      align: 'center',
      useGraphSettings: true,
      equalWidths: false,
      marginRight: 40,
      horizontalGap: 30,
      markerLabelGap: 10,
      rollOverGraphAlpha: 0,
      spacing: 30,
      valueText: '',
    },
  },
});
